module.exports = __webpack_public_path__ + "img/php.cdf5b5e1.svg";